import {
  Grid, Segment, Header, Button,
} from 'semantic-ui-react';

import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import GraficoMovimentacaoSocios from './components/GraficoMovimentacaoSocios';
import BarraNumeros from './components/BarraNumeros';
import GraficoCipasPorRegional from './components/GraficoCipasPorRegional';
import GraficoAcordosPlrAno from './components/GraficoAcordosPlrAno';
import GraficoAcordosAno from './components/GraficoAcordosAno';
import { podeVerJuridico } from '../../utils/permissoes';

const ANO_ATUAL = new Date().getFullYear();

function Dashboard() {
  const navigate = useNavigate();
  const login = useSelector((state) => state.login);
  const usuario = login.usuario;

  const irParaManuais = () => navigate('/manuais');

  const irParaFinanceiro = () => navigate('/financeiro');

  const irParaJuridico = () => navigate('/juridico');

  const irParaAcervo = () => window.location.replace(
    'https://sist.sintrabor.org.br/acervo-digital',
  );

  const irParaGestaoAcessos = () => window.open(
    'https://docs.google.com/forms/d/e/1FAIpQLSfSRwnL_TVhtHjzvTKtxR0K5-fmDRqCXdcGS_1KB9ohpdQpuQ/viewform',
    '_blank',
    'noopener,noreferrer',
  );

  const irParaPangeo = () => window.location.replace(
    'https://sist.sintrabor.org.br/pangeo',
  );

  const irParaCadastro = () => window.location.replace(
    `https://sist.sintrabor.org.br/atw/#!/login?token=${login.token}`,
  );

  const irParaCi = () => window.location.replace(
    'https://sist.sintrabor.org.br/den',
  );

  const irParaComunicaEmpresa = () => window.location.replace(
    'https://sist.sintrabor.org.br/comunica-empresa',
  );

  const vePangeo = () => {
    return usuario?.demais_dados?.recursos
      .filter((recurso) => recurso.split(".")[0] === "pangeo").length > 0
  };

  const veDen = () => {
    return usuario?.demais_dados?.recursos
      .filter((recurso) => recurso.split(".")[0] === "denBgp").length > 0
  };

  const veArrecadacao = () => {
    return usuario?.demais_dados?.recursos
      .filter((recurso) => recurso.split(".")[0] === "arrecadacao").length > 0
  };

  const veTodosGraficos = () => {
    return usuario?.demais_dados?.recursos
      .filter((recurso) => recurso.split(".")[0] === "intranetBgp").length > 0
  }

  const veJuridico = () => podeVerJuridico(login);

  const veAcervo = () => {
    return usuario?.demais_dados?.recursos
      .filter((recurso) => recurso.split(".")[0] === "acervoBgp").length > 0
  };

  const veCadastro = () => {
    return usuario?.demais_dados?.recursos
      .filter((recurso) => recurso.split(".")[0] === "atw").length > 0
  };

  return (
    <>
      <Header as="h3">Dashboard</Header>

      <Grid columns="equal">
        {vePangeo() ? <BarraNumeros /> : null}
        <div className="menu-sistemas">
          <span className="header-menu">Ir para: </span>

          <Button basic onClick={irParaManuais}>
            <img src="logo_manuais.png" alt="logo_manuais" />
            <span>Manuais e Procedimentos</span>
          </Button>

          {veAcervo() ? (
            <Button basic onClick={irParaAcervo}>
              <img src="logo_ci.png" alt="logo_acervo" />
              <span>Acervo Digital</span>
            </Button>
          ) : null}

          <Button basic onClick={irParaGestaoAcessos}>
            <img src="logo_ci.png" alt="logo_gestao_acessos" />
            <span>Gestão de Acessos</span>
          </Button>

          {veCadastro() ? (
            <Button basic onClick={irParaCadastro}>
              <img src="logo_ci.png" alt="logo_cadastro" />
              <span>Arpan Web</span>
            </Button>
          ) : null}

          {vePangeo() ? (
            <Button basic onClick={irParaPangeo}>
              <img src="logo_pangeo.png" alt="logo_pangeo" />
              <span>Pangeo</span>
            </Button>
          ) : null}

          {veDen() ? (
            <Button basic onClick={irParaCi}>
              <img src="logo_ci.png" alt="logo_ci" />
              <span>Comunicação Interna</span>
            </Button>
          ) : null}

          {veArrecadacao() ? (
            <Button basic onClick={irParaComunicaEmpresa}>
              <img src="logo_ci.png" alt="logo_ci" />
              <span>Arrecadação - Comunica empresas</span>
            </Button>
          ) : null}

          {veTodosGraficos() && false ? <Button basic onClick={irParaFinanceiro}>
            <img src="logo_financeiro.png" alt="logo_financeiro" />
            <span>Painel Financeiro</span>
          </Button> : null}

          {veJuridico() ? (
            <Button basic onClick={irParaJuridico}>
              <img src="logo_juridico.png" alt="logo_juridico" />
              <span>Jurídico</span>
            </Button>
          ) : null}
        </div>

        {veTodosGraficos() && vePangeo() ? (
          <Grid.Row stretched className="grupo-graficos">
            <Grid.Column mobile={16} tablet={8} computer={3}>
              <Segment>
                <Link
                  to="/cipas?filtro=ativas"
                  className="ui green right corner label"
                >
                  <i className="plus icon" />
                </Link>
                <GraficoCipasPorRegional />
              </Segment>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={5}>
              <Segment>
                <Link
                  to={`/acordos-plr?ano=${ANO_ATUAL}&tipoApuracao=vigencia`}
                  className="ui green right corner label"
                >
                  <i className="plus icon" />
                </Link>
                <GraficoAcordosPlrAno />
              </Segment>
              <Segment>
                <Link
                  to={`/acordos?ano=${ANO_ATUAL}`}
                  className="ui green right corner label"
                >
                  <i className="plus icon" />
                </Link>
                <GraficoAcordosAno />
              </Segment>
            </Grid.Column>
            <Grid.Column tablet={8} mobile={16} computer={8}>
              <Segment>
                <GraficoMovimentacaoSocios />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        ) : null}
      </Grid>
    </>
  );
}

export default Dashboard;
